import React from 'react';
import { Box, Text, useTheme } from '@chakra-ui/react';

const DatabaseProgress = ({ value }) => {
    const theme = useTheme();

    const color = theme.colors.secondary; 
    const safeValue = value || 0;

    return (
        <Box>
            <Box w="100%" bg="gray.700" borderRadius="md" h="10px" overflow="hidden">
                <Box h="10px" bg={color} width={`${safeValue}%`} transition="width 0.3s ease-in-out" />
            </Box>
            
            <Text 
                fontSize="xs" 
                color={color} 
                fontWeight="bold" 
                mt={1}
            >
                {safeValue.toFixed(2)}% Utilizado
            </Text>
        </Box>
    );
};

export default DatabaseProgress;